/**
 * URLから講師か受講生か判定
 * @returns {String} admin / student
 */
export const getUserRole = (route: any) => {
  const pathList = route.path.split('/');
  const postUser = pathList[pathList.length - 1];

  return postUser;
};
